var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64 6.23089C9.49393 6.10923 9.31621 6.03172 9.12767 6.00745C8.93913 5.98318 8.74757 6.01316 8.57545 6.09386C8.40334 6.17457 8.25779 6.30266 8.15587 6.46313C8.05395 6.6236 7.99988 6.80979 8 6.99989V16.9999C8.00013 17.1899 8.05437 17.3759 8.15638 17.5362C8.25839 17.6964 8.40394 17.8243 8.576 17.9049C8.70854 17.9676 8.85337 18 9 17.9999C9.23378 18.0001 9.46023 17.9183 9.64 17.7689L15.64 12.7689C15.7529 12.6751 15.8437 12.5575 15.9061 12.4246C15.9684 12.2917 16.0008 12.1467 16.0008 11.9999C16.0008 11.8531 15.9684 11.7081 15.9061 11.5752C15.8437 11.4423 15.7529 11.3247 15.64 11.2309L9.64 6.23089Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.3ac48b9fabd7074efaa570f5279c247b.svg";
export { ForwardRef as ReactComponent };